import { StackView, GridView, Icon, Text, Button, Collapse, Avatar } from '@planningcenter/tapestry-react';
import React, { useState } from 'react';
import colors from '../vendor/topbar/colors.js';

const COLUMNS = "18px 1fr auto";
const ChildNotice = ({ childPeople, }) => {
    const [open, setOpen] = useState(false);
    const childCount = childPeople.length;
    const childCountLabel = childCount === 1 ? "member" : "members";
    const summary = `${childCount} ${childCountLabel} under age 13`;
    const explanation = `Members under age 13 cannot chat. They will not see conversations or receive notifications.`;
    return (React.createElement(StackView, { background: colors.warning94, marginBottom: 0.5, padding: 1, radius: 4 },
        React.createElement(GridView, { alignment: "start", columns: COLUMNS, spacing: 1 },
            React.createElement(Icon, { color: colors.warning49, marginTop: "1px", name: "general.shieldExclamation", size: "lg" }),
            React.createElement(Text, { grow: 1, color: "foreground", size: 4 }, open ? explanation : summary),
            React.createElement(Button, { "aria-label": open ? "Hide explanation" : "Show explanation", icon: {
                    name: open ? "general.upCaret" : "general.downCaret",
                    size: "md",
                }, onClick: () => setOpen(!open), size: "xs", theme: "warning", tooltip: open ? "Hide explanation" : "Show explanation", variant: "naked" })),
        React.createElement(Collapse, { open: open },
            React.createElement(GridView, { alignment: "start", columns: COLUMNS, spacing: 1 },
                React.createElement(StackView, { gridColumnStart: 2, paddingTop: 1, spacing: 1 }, childPeople.map((person) => (React.createElement(StackView, { alignment: "center", axis: "horizontal", key: person.id, spacing: 1 },
                    React.createElement(Avatar, { src: person.avatar, size: "sm" }),
                    React.createElement(Text, { color: "foreground", size: 4, weight: 500 }, person.name)))))))));
};

export { ChildNotice };
//# sourceMappingURL=child_notice.js.map
